const EXCLUSIVE_PRODUCT_INFO_TAG = '단독';

export interface ExclusiveEmblemSource {
  infoTags?: string[];
}

export function isExclusiveProduct(product: ExclusiveEmblemSource): boolean {
  return product.infoTags?.includes(EXCLUSIVE_PRODUCT_INFO_TAG) ?? false;
}

/** show가 true일 때만 infoTags '단독' 기준으로 exclusive prop 반환 */
export function getExclusiveEmblemProp(
  product: ExclusiveEmblemSource,
  show?: boolean
): boolean | undefined {
  if (!show) {
    return undefined;
  }

  return isExclusiveProduct(product) || undefined;
}
